import {v4 as uuidv4} from 'uuid';
import { SettingsOfflinePluginSettings } from "../pluginSettings/SettingsOfflinePluginSettings";

export const SettingsOfflineTab = (): ITab => {
    return {
      id: uuidv4(),
      title: SettingsOfflinePluginSettings.name,
      view: {
        content: <></>
      }
    }
  }
  